<template src="./sendmessage.html"></template>
<script>

import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
  export default {
    props: ["selectedUsers",'heading','defaultHeading','defaultMessage'],
    data() {
      return {
        SendNotification: {
          push_subject: this.defaultHeading,
          push_message: this.defaultMessage,
        },
        NotificationSubmitted: false,
        submitted: false,

      };
    },
    validations: {
      SendNotification: {
        push_subject: { required },
        push_message: { required },
      },
    },
    mounted() {
      this.CompanyDetails = JSON.parse(localStorage.getItem("CompanyDetails"));
    },
    methods: {
      saveMessage() {
        this.SendNotification.selectedUsers = this.selectedUsers;
        this.NotificationSubmitted = true;
        this.sendMessage();
      },
      sendMessage() {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          
        this.NotificationSubmitted = false;
          return;
        }
        this.NotificationSubmitted = true;
        axios
          .post(Endpoints.Driver.SendCustomNotification, {
            token: localStorage.getItem("token"),
            ...this.SendNotification,
          })
          .then((Response) => {
            this.NotificationSubmitted = false;
            this.submitted = false;
            if (Response.data.success) {
              this.$swal
                .fire("Notification has been Sent Successfully", "", "success")
                .then(() => {
                  //reset data
                  setTimeout(() => {
                    this.$emit("messageSent");
                  }, 1000);
                });
            } else {
              this.NotificationSubmitted = false;
              this.submitted = false;
              this.$swal.fire({
                title: "Alert!",
                text: Response.data.message,
                icon: "error",
                confirmButtonText: "Close",
              });
            }
          });
      },
    },
  };
</script>
<style scoped>
  #send-message___BV_modal_outer_ {
    z-index: 1050 !important;
  }
</style>
